module.exports = __webpack_public_path__ + "static/media/help.0d9d2211.png";